import { AuditQuestionType, AuditResponseType } from '@arhs-fleetback/types/entities/audits';

// Sourced from the package's `AuditQuestionType` (BE source of truth), keeping the project's
// SCREAMING_SNAKE_CASE keys so call sites (`AuditQuestionTypeEnum.AUTHOR`, etc.) don't change.
export const AuditQuestionTypeEnum = {
  REFERENCE: AuditQuestionType.ReferenceQuestion,
  AUTHOR: AuditQuestionType.AuthorQuestion,
  BARCODE: AuditQuestionType.BarCodeQuestion,
  BRAND: AuditQuestionType.BrandQuestion,
  CHECKBOX: AuditQuestionType.CheckboxQuestion,
  DATETIME: AuditQuestionType.DateTimeQuestion,
  EMAIL: AuditQuestionType.EmailQuestion,
  EMPLOYEE: AuditQuestionType.EmployeeQuestion,
  EXPLODED_VIEW: AuditQuestionType.ExplodedViewQuestion,
  MEDIA: AuditQuestionType.MediaQuestion,
  MULTI_EMPLOYEE: AuditQuestionType.MultiEmployeeQuestion,
  NUMBER: AuditQuestionType.NumberQuestion,
  PADS_THICKNESS: AuditQuestionType.PadsThicknessQuestion,
  RADIO_BUTTON: AuditQuestionType.RadioButtonQuestion,
  SEVERITY: AuditQuestionType.SeverityQuestion,
  SIGNATURE: AuditQuestionType.SignatureQuestion,
  TEXTBOX: AuditQuestionType.TextboxQuestion,
  THICKNESS: AuditQuestionType.ThicknessQuestion,
  TIRE_REPORT: AuditQuestionType.TireReportQuestion,
  YES_NO: AuditQuestionType.YesNoQuestion,
  KPI: AuditQuestionType.KPIQuestion,
} as const;

export type AuditQuestionTypeEnum = typeof AuditQuestionTypeEnum[keyof typeof AuditQuestionTypeEnum];

// Sourced from the package's `AuditResponseType` (BE source of truth), keeping the project's
// SCREAMING_SNAKE_CASE keys so call sites (`AuditResponseTypeEnum.AUTHOR`, etc.) don't change.
export const AuditResponseTypeEnum = {
  REFERENCE: AuditResponseType.ReferenceResponse,
  AUTHOR: AuditResponseType.AuthorResponse,
  BARCODE: AuditResponseType.BarCodeResponse,
  BRAND: AuditResponseType.BrandResponse,
  CHECKBOX: AuditResponseType.CheckboxResponse,
  DATETIME: AuditResponseType.DateTimeResponse,
  EMAIL: AuditResponseType.EmailResponse,
  EMPLOYEE: AuditResponseType.EmployeeResponse,
  EXPLODED_VIEW: AuditResponseType.ExplodedViewResponse,
  KPI: AuditResponseType.KPIResponse,
  MEDIA: AuditResponseType.MediaResponse,
  MULTI_EMPLOYEE: AuditResponseType.MultiEmployeeResponse,
  NUMBER: AuditResponseType.NumberResponse,
  PADS_THICKNESS: AuditResponseType.PadsThicknessResponse,
  RADIO_BUTTON: AuditResponseType.RadioButtonResponse,
  SEVERITY: AuditResponseType.SeverityResponse,
  SIGNATURE: AuditResponseType.SignatureResponse,
  TEXTBOX: AuditResponseType.TextboxResponse,
  THICKNESS: AuditResponseType.ThicknessResponse,
  TIRE_REPORT: AuditResponseType.TireReportResponse,
  YES_NO: AuditResponseType.YesNoResponse,
} as const satisfies Record<keyof typeof AuditQuestionTypeEnum, string>;

export type AuditResponseTypeEnum = typeof AuditResponseTypeEnum[keyof typeof AuditResponseTypeEnum];
